export const SUPPLIER_EXTERNAL_ID_MIN_LENGTH = 1;
export const SUPPLIER_EXTERNAL_ID_MAX_LENGTH = 100;
export const SUPPLIER_NAME_MIN_LENGTH = 1;
export const SUPPLIER_NAME_MAX_LENGTH = 100;
export const SUPPLIER_PHONE_MIN_LENGTH = 7;
export const SUPPLIER_PHONE_MAX_LENGTH = 50;
export const SUPPLIER_DESCRIPTION_MIN_LENGTH = 1;
export const SUPPLIER_DESCRIPTION_MAX_LENGTH = 500;
export const SUPPLIER_CONTACT_INFO_MIN_LENGTH = 1;
export const SUPPLIER_CONTACT_INFO_MAX_LENGTH = 1000;
